export default {
  'pages.layouts.userLayout.title':
    'Ant Design 是西湖区最具影响力的 Web 设计规范',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.login.welcome': '欢迎使用智能视频处理平台',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.noauth.createTitle': '创建无认证接口',
  'pages.noauth.editTitle': '编辑无认证接口',
  'pages.noauth.updatedSuccessfully': '更新成功',
  'pages.noauth.createdSuccessfully': '创建成功',
  'pages.noauth.updateFailed': '更新失败，请重试',
  'pages.noauth.createFailed': '创建失败，请重试',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',
  'pages.dict.typeTitle': '字典类型',
  'pages.dict.dataTitle': '字典数据',
  'pages.dict.createDictTypeTitle': '创建字典类型',
  'pages.dict.editDictTypeTitle': '编辑字典类型',
  'pages.dict.createDictDataTitle': '创建字典数据',
  'pages.dict.editDictDataTitle': '编辑字典数据',
  'pages.dict.dictTypeName': '字典名称',
  'pages.dict.dictType': '字典类型',
  'pages.dict.dictTypePlaceholder': '请输入字典类型',
  'pages.dict.remark': '备注',
  'pages.dict.remarkPlaceholder': '请输入备注',
  'pages.dict.status': '状态',
  'pages.dict.enabled': '启用',
  'pages.dict.disabled': '禁用',
  'pages.dict.parentDictType': '上级字典类型',
  'pages.dict.selectParentDictType': '请选择上级字典类型',
  'pages.dict.label': '标签',
  'pages.dict.value': '值',
  'pages.dict.sort': '排序',
  'pages.dict.operation': '操作',
  'pages.dict.edit': '编辑',
  'pages.dict.delete': '删除',
  'pages.dict.add': '新增',
  'pages.dict.searchPlaceholder': '搜索字典数据',
  'pages.dict.createNew': '新建',
  'pages.dict.cancel': '取消',
  'pages.dict.submit': '提交',
  'pages.dict.confirmDelete': '确认删除',
  'pages.dict.deleteConfirmMsg': '确定要删除该项吗？',
  'pages.dict.deleteSuccess': '删除成功',
  'pages.dict.createSuccess': '创建成功',
  'pages.dict.updateSuccess': '更新成功',
  'pages.dict.createFailed': '创建失败',
  'pages.dict.updateFailed': '更新失败',
  'pages.dict.loadFailed': '加载失败',
  'pages.dict.parentDictData': '上级字典数据',
  'pages.dict.inputParentDictData': '请输入上级字典数据ID，留空表示无上级',
  'pages.role.createTitle': '创建角色',
  'pages.role.editTitle': '编辑角色',
  'pages.role.updatedSuccessfully': '更新成功',
  'pages.role.createdSuccessfully': '创建成功',
  'pages.role.updateFailed': '更新失败，请重试',
  'pages.role.createFailed': '创建失败，请重试',
  'pages.role.detailTitle': '角色详情',
  'pages.role.name': '角色名称',
  'pages.role.orgName': '组织名称',
  'pages.role.roleType': '角色类型',
  'pages.role.orgType': '组织类型',
  'pages.role.management': '角色管理',
  'pages.role.new': '新增角色',
  'pages.role.name.required': '角色名称必填',
  'pages.role.name.placeholder': '请输入角色名称',
  'pages.role.orgName.required': '组织名称必填',
  'pages.role.orgName.placeholder': '请输入组织名称',
  'pages.role.roleType.placeholder': '请输入角色类型',
  'pages.role.remark': '备注',
  'pages.role.remark.placeholder': '请输入备注',
  'pages.role.createdAt': '创建时间',
  'pages.role.updatedAt': '更新时间',
  'pages.role.detail': '详情',
  'pages.role.edit': '编辑',
  'pages.role.delete': '删除',
  'pages.role.deleteConfirm': '确定删除此项吗？',
  'pages.role.okText': '确定',
  'pages.role.cancelText': '取消',
  'pages.orgdept.name': '部门名称',
  'pages.orgdept.name.required': '部门名称必填',
  'pages.orgdept.name.placeholder': '请输入部门名称',
  'pages.orgdept.parentId': '上级部门ID',
  'pages.orgdept.parentId.placeholder': '请输入上级部门ID',
  'pages.orgdept.orgId': '组织ID',
  'pages.orgdept.orgId.placeholder': '请输入组织ID',
  'pages.orgdept.remark': '备注',
  'pages.orgdept.remark.placeholder': '请输入备注',
  'pages.orgdept.detailTitle': '部门详情',
  'pages.orgdept.createTitle': '创建部门',
  'pages.orgdept.editTitle': '编辑部门',
  'pages.orgdept.updatedSuccessfully': '更新成功',
  'pages.orgdept.createdSuccessfully': '创建成功',
  'pages.orgdept.updateFailed': '更新失败，请重试',
  'pages.orgdept.createFailed': '创建失败，请重试',
  'pages.orgdept.orgName': '组织名称',
  'pages.orgdept.createdAt': '创建时间',
  'pages.orgdept.updatedAt': '更新时间',
  'pages.orgpost.name': '岗位名称',
  'pages.orgpost.name.required': '岗位名称必填',
  'pages.orgpost.name.placeholder': '请输入岗位名称',
  'pages.orgpost.orgId': '组织ID',
  'pages.orgpost.orgId.placeholder': '请输入组织ID',
  'pages.orgpost.desc': '岗位描述',
  'pages.orgpost.desc.placeholder': '请输入岗位描述',
  'pages.orgpost.detailTitle': '岗位详情',
  'pages.orgpost.createTitle': '创建岗位',
  'pages.orgpost.editTitle': '编辑岗位',
  'pages.orgpost.updatedSuccessfully': '更新成功',
  'pages.orgpost.createdSuccessfully': '创建成功',
  'pages.orgpost.updateFailed': '更新失败，请重试',
  'pages.orgpost.createFailed': '创建失败，请重试',
  'pages.orgpost.orgName': '组织名称',
  'pages.orgpost.orgId.required': '组织ID必填',
  'pages.orgpost.createdAt': '创建时间',
  'pages.orgpost.updatedAt': '更新时间',
  'pages.orgdept.management': '部门管理',
  'pages.orgdept.new': '新增',
  'pages.orgtree.management': '组织架构',
  'pages.orgtree.new': '新增组织',
  'pages.orgtree.addChild': '新增子组织',
  'pages.orgtree.edit': '编辑组织',
  'pages.orgtree.detail': '组织详情',
  'pages.orgtree.delete': '删除组织',
  'pages.orgtree.manageDepts': '部门管理',
  'pages.orgtree.managePosts': '岗位管理',
  'pages.orgtree.manageEmployees': '员工管理',
  'pages.orgtree.deleteConfirm': '确定删除此组织吗？',
  'pages.orgtree.createTitle': '创建组织',
  'pages.orgtree.editTitle': '编辑组织',
  'pages.orgtree.detailTitle': '组织详情',
  'pages.orgtree.updatedSuccessfully': '组织更新成功',
  'pages.orgtree.createdSuccessfully': '组织创建成功',
  'pages.orgtree.updateFailed': '组织更新失败，请重试',
  'pages.orgtree.createFailed': '组织创建失败，请重试',
  'pages.orgtree.deleteSuccess': '组织删除成功',
  'pages.orgtree.deleteFailed': '组织删除失败',
  'pages.orgtree.fetchDetailFailed': '获取组织详情失败',
  'pages.orgtree.name': '组织名称',
  'pages.orgtree.name.required': '组织名称必填',
  'pages.orgtree.name.placeholder': '请输入组织名称',
  'pages.orgtree.code': '组织编码',
  'pages.orgtree.code.required': '组织编码必填',
  'pages.orgtree.code.placeholder': '请输入组织编码',
  'pages.orgtree.type': '组织类型',
  'pages.orgtree.type.placeholder': '请选择组织类型',
  'pages.orgtree.contact': '联系人',
  'pages.orgtree.contact.placeholder': '请输入联系人',
  'pages.orgtree.phone': '联系电话',
  'pages.orgtree.phone.placeholder': '请输入联系电话',
  'pages.orgtree.email': '邮箱',
  'pages.orgtree.email.placeholder': '请输入邮箱',
  'pages.orgtree.address': '地址',
  'pages.orgtree.address.placeholder': '请输入地址',
  'pages.orgtree.sort': '排序',
  'pages.orgtree.sort.placeholder': '请输入排序号',
  'pages.orgtree.orgTyp': '组织类型',
  'pages.orgtree.orgTyp.placeholder': '请选择组织类型',
  'pages.orgtree.orgTyp.company': '公司',
  'pages.orgtree.orgTyp.department': '部门',
  'pages.orgtree.orgTyp.group': '集团',
  'pages.orgtree.orgTyp.branch': '分公司',
  'pages.orgtree.uscc': '统一社会信用代码',
  'pages.orgtree.uscc.placeholder': '请输入统一社会信用代码',
  'pages.orgtree.enabled': '状态',
  'pages.orgtree.remark': '备注',
  'pages.orgtree.remark.placeholder': '请输入备注',
  'pages.orgtree.parentId': '上级组织',
  'pages.orgtree.parentId.placeholder': '请选择上级组织，不选则为顶级',
  'pages.orgtree.createdAt': '创建时间',
  'pages.orgtree.updatedAt': '更新时间',
  'pages.orgtree.refresh': '刷新',
  'pages.orgpost.management': '岗位管理',
  'pages.orgpost.new': '新增',
  'pages.orgdept.detail': '详情',
  'pages.orgdept.edit': '编辑',
  'pages.orgdept.delete': '删除',
  'pages.orgdept.deleteConfirm': '确定删除此项吗？',
  'pages.orgdept.okText': '确定',
  'pages.orgdept.cancelText': '取消',
  'pages.orgdept.fetchDetailFailed': '获取详情失败',
  'pages.orgdept.deleteSuccess': '删除成功',
  'pages.orgdept.deleteFailed': '删除失败',
  'pages.orgpost.detail': '详情',
  'pages.orgpost.edit': '编辑',
  'pages.orgpost.delete': '删除',
  'pages.orgpost.deleteConfirm': '确定删除此项吗？',
  'pages.orgpost.okText': '确定',
  'pages.orgpost.cancelText': '取消',
  'pages.orgpost.fetchDetailFailed': '获取详情失败',
  'pages.orgpost.deleteSuccess': '删除成功',
  'pages.orgpost.deleteFailed': '删除失败',
  'pages.role.deleteSuccess': '删除成功',
  'pages.role.deleteFailed': '删除失败',
  'pages.role.fetchDetailFailed': '获取详情失败',
  'pages.menu.createTitle': '创建菜单',
  'pages.menu.editTitle': '编辑菜单',
  'pages.menu.detailTitle': '菜单详情',
  'pages.menu.updatedSuccessfully': '更新成功',
  'pages.menu.createdSuccessfully': '创建成功',
  'pages.menu.updateFailed': '更新失败，请重试',
  'pages.menu.createFailed': '创建失败，请重试',
  'pages.employee.management': '员工管理',
  'pages.employee.new': '新增员工',
  'pages.employee.detail': '详情',
  'pages.employee.edit': '编辑',
  'pages.employee.delete': '删除',
  'pages.employee.deleteConfirm': '确定删除此项吗？',
  'pages.employee.okText': '确定',
  'pages.employee.cancelText': '取消',
  'pages.employee.deleteSuccess': '删除成功',
  'pages.employee.deleteFailed': '删除失败',
  'pages.employee.fetchDetailFailed': '获取详情失败',
  'pages.employee.createTitle': '创建员工',
  'pages.employee.editTitle': '编辑员工',
  'pages.employee.detailTitle': '员工详情',
  'pages.employee.updatedSuccessfully': '更新成功',
  'pages.employee.createdSuccessfully': '创建成功',
  'pages.employee.updateFailed': '更新失败，请重试',
  'pages.employee.createFailed': '创建失败，请重试',
  'pages.employee.employeeNumber': '员工编号',
  'pages.employee.name': '姓名',
  'pages.employee.organization': '组织',
  'pages.employee.department': '部门',
  'pages.employee.position': '职位',
  'pages.employee.role': '角色',
  'pages.employee.status': '状态',
  'pages.employee.active': '启用',
  'pages.employee.inactive': '禁用',
  'pages.employee.remark': '备注',
  'pages.employee.namePlaceholder': '请输入姓名!',
  'pages.employee.employeeId': '员工ID',
  'pages.employee.employeeIdPlaceholder': '请输入员工ID',
  'pages.employee.selectDepartment': '请选择部门',
  'pages.employee.selectPosition': '请选择职位',
  'pages.employee.operation': '操作',
  'pages.employee.deleteConfirmContent': '确定删除此员工吗？',

  // 设备管理模块国际化
  'pages.device.management': '设备管理',
  'pages.device.gateway': '网关',
  'pages.device.terminal': '终端',
  'pages.device.noData': '暂无设备数据',
  'pages.device.noDataDescription': '当前没有任何设备数据，请先创建网关设备',
  'pages.device.createGateway': '新建网关',
  'pages.device.refresh': '刷新',
  'pages.device.viewDetails': '查看详情',
  'pages.device.online': '在线',
  'pages.device.offline': '离线',
  'pages.device.hasChild': '有子设备',
  'pages.device.noChild': '无子设备',

  // 事件管理模块通用国际化
  'pages.event.management': '事件管理',
  'pages.event.record': '事件记录',
  'pages.event.order': '事件工单',
  'pages.event.node': '工单节点',
  'pages.event.receiver': '事件接收者',
  'pages.event.resource': '资源文件',
  'pages.event.create': '创建',
  'pages.event.edit': '编辑',
  'pages.event.delete': '删除',
  'pages.event.view': '查看',
  'pages.event.refresh': '刷新',
  'pages.event.search': '搜索',
  'pages.event.confirmDelete': '确认删除',
  'pages.event.deleteSuccess': '删除成功',
  'pages.event.deleteFailed': '删除失败',
  'pages.event.createSuccess': '创建成功',
  'pages.event.updateSuccess': '更新成功',
  'pages.event.operation': '操作',

  // 事件接收者模块国际化
  'pages.eventReceiver.management': '事件接收者管理',
  'pages.eventReceiver.name': '接收器名称',
  'pages.eventReceiver.type': '接收器类型',
  'pages.eventReceiver.endpoint': '端点地址',
  'pages.eventReceiver.description': '描述',
  'pages.eventReceiver.status': '状态',
  'pages.eventReceiver.createTitle': '创建事件接收器',
  'pages.eventReceiver.editTitle': '编辑事件接收器',
  'pages.eventReceiver.viewTitle': '查看事件接收器',
  'pages.eventReceiver.namePlaceholder': '请输入接收器名称',
  'pages.eventReceiver.typePlaceholder': '请选择接收器类型',
  'pages.eventReceiver.endpointPlaceholder': '请输入端点地址',
  'pages.eventReceiver.descriptionPlaceholder': '请输入描述信息',
  'pages.eventReceiver.email': '邮件',
  'pages.eventReceiver.webhook': 'Webhook',
  'pages.eventReceiver.sms': '短信',
  'pages.eventReceiver.mqtt': 'MQTT',
  'pages.eventReceiver.enabled': '启用',
  'pages.eventReceiver.disabled': '禁用',
  'pages.eventReceiver.deleteConfirm': '确定要删除该事件接收器吗？',

  // 资源文件模块国际化
  'pages.resourceFile.management': '资源文件管理',
  'pages.resourceFile.name': '文件名称',
  'pages.resourceFile.type': '文件类型',
  'pages.resourceFile.size': '文件大小',
  'pages.resourceFile.path': '文件路径',
  'pages.resourceFile.description': '描述',
  'pages.resourceFile.tags': '标签',
  'pages.resourceFile.status': '状态',
  'pages.resourceFile.uploadTime': '上传时间',
  'pages.resourceFile.uploader': '上传者',
  'pages.resourceFile.createTitle': '创建资源文件',
  'pages.resourceFile.editTitle': '编辑资源文件',
  'pages.resourceFile.viewTitle': '查看资源文件',
  'pages.resourceFile.namePlaceholder': '请输入文件名称',
  'pages.resourceFile.typePlaceholder': '请选择文件类型',
  'pages.resourceFile.descriptionPlaceholder': '请输入文件描述',
  'pages.resourceFile.tagsPlaceholder': '请输入标签，按回车确认',
  'pages.resourceFile.uploadPlaceholder': '点击上传文件',
  'pages.resourceFile.fileRequired': '请选择要上传的文件',
  'pages.resourceFile.fileSizeLimit': '文件大小不能超过 100MB',
  'pages.resourceFile.download': '下载',
  'pages.resourceFile.preview': '预览',
};
